import { getActiveConsultation, getConsultationHistory, respondToConsultation } from "../../../Common/axios_instance/video_https/video.https";
import { updateDoctorStatus } from "../../../Common/axios_instance/auth_https/auth.https";
import { ConsultationHistoryParams } from "../../../Common/axios_instance/video_https/interfaces/video_https.interface";

export const fetchActiveConsultation = () => getActiveConsultation();

export const fetchRecentHistory = (params: ConsultationHistoryParams) => getConsultationHistory(params);

export const toggleDoctorStatus = (doctorId: string, status: "online" | "offline") =>
  updateDoctorStatus(doctorId, status);

export const respondConsultation = (
  consultationId: string,
  status: "accepted" | "rejected"
) => respondToConsultation(consultationId, status);
